var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{ref:"gameLink",staticClass:"home-game-element",style:({ 'height': _vm.homeHeight + 'px' }),attrs:{"to":'/' + _vm.homeGetLink}},[_c('img',{attrs:{"src":require('@/assets/img/games/backup/' + _vm.game + '.webp')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }